module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/468.493cce3d.png";